<template>
  <div>
    <Header />
    <div class="page404 centerPage">
      <img src="~images/logo.svg" alt="" />
        We cannot find the page you’re looking for.
    </div>
  </div>
</template>

<script>
import mixins from 'src/mixins.js';
import { mapState } from 'vuex';
import Header from '../elements/Header';
import { ANALYTICS } from '../../firebase-config';

export default {
  mixins: [mixins],
  components: { Header },
  data() {
    return {};
  },
  computed: {
    ...mapState(['userInfo', 'userInfoLoaded', 'currentWorkspace', 'workspaces'])
  },
  methods: {
    userInfoCheck: function () {
      this.subscribeAllWorkspacesMixin()
    },
    workspacesCheck: function () {
      this.setCurrentWorkspaceMixin()
    }
  },
  mounted() {
    ANALYTICS.logEvent('page_view');
  }
};
</script>

<style scoped></style>
